import { MockServiceStore } from "./MockServiceStore";

/**
 * StructureCast - Shipment Load (a single truck load)
 */
export interface StructureCastShipmentLoad {
  id: string;
  shipmentId: string;
  loadNumber: number;
  structures: string[];
  components: string[];
  totalWeight: number;
  weightCapacity: number;
  notes: string;
  createdAt: string;
  updatedAt: string;
}

export const mockStructureCastShipmentLoads: StructureCastShipmentLoad[] = [
  {
    id: "sc-load-1",
    shipmentId: "sc-ship-1",
    loadNumber: 1,
    structures: ["sc-struct-01", "sc-struct-02"],
    components: [],
    totalWeight: 23320,
    weightCapacity: 44000,
    notes: "SSMH-01 (8.5') + SSMH-02 (7.5') — deep manhole sections: 2 bases, 48\" + 36\" risers, 36\" eccentric cones, grade rings. Cured 7+ days.",
    createdAt: "2026-01-15T00:00:00.000Z",
    updatedAt: "2026-01-20T00:00:00.000Z",
  },
  {
    id: "sc-load-2",
    shipmentId: "sc-ship-2",
    loadNumber: 1,
    structures: ["sc-struct-03", "sc-struct-04", "sc-struct-05"],
    components: [],
    totalWeight: 30255,
    weightCapacity: 44000,
    notes: "SSMH-03 + SSMH-04 + SSMH-05 — standard depth manhole sections. 24\"/12\" risers, 36\"/24\" eccentric cones.",
    createdAt: "2026-01-28T00:00:00.000Z",
    updatedAt: "2026-01-28T00:00:00.000Z",
  },
  {
    id: "sc-load-3",
    shipmentId: "sc-ship-2",
    loadNumber: 2,
    structures: ["sc-struct-06", "sc-struct-07"],
    components: [],
    totalWeight: 17765,
    weightCapacity: 44000,
    notes: "SSMH-06 + SSMH-07 — mid-depth manhole sections (Cabrillo Way + Lakeview Dr).",
    createdAt: "2026-01-28T00:00:00.000Z",
    updatedAt: "2026-01-28T00:00:00.000Z",
  },
  {
    id: "sc-load-4",
    shipmentId: "sc-ship-2",
    loadNumber: 3,
    structures: ["sc-struct-08", "sc-struct-09"],
    components: [],
    totalWeight: 16940,
    weightCapacity: 44000,
    notes: "SSMH-08 + SSMH-09 — shallow manhole sections (Lakeview Dr / Pinion Trail).",
    createdAt: "2026-01-28T00:00:00.000Z",
    updatedAt: "2026-01-28T00:00:00.000Z",
  },
];

export const createMockStructureCastShipmentLoadStore = () =>
  new MockServiceStore<StructureCastShipmentLoad>({
    mockData: mockStructureCastShipmentLoads,
    idField: "id",
    simulateDelay: 200,
    persistKey: "preferred-structurecast-shipment-loads",
  });

export default mockStructureCastShipmentLoads;
